/* eslint-disable max-len */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon, Flex } from 'ui';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  updateDefaultExpand,
} from '../../worklist/containers/worklist-actions';

const StyledIcon = styled(Icon)`
  color: #181d1f;
  cursor: pointer;
  margin-left: 3px;
  transition: all 0.2s linear;
  transform-origin: center;
  transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
  &:hover {
    color: ${p => p.theme.colors.theme};
  }
`;

const StyledCheckboxWrapper = styled.div`
  margin-left: 15px;
`;

const MasterDetailHeader = ({ allChildrenCheckBox = false }) => {
  const dispatch = useDispatch();
  const defaultExpanded = useSelector(state => state.worklist.defaultExpanded);

  const [checkboxState, setCheckboxState] = useState();

  const onClick = () => {
    dispatch(updateDefaultExpand(!defaultExpanded));
  };

  const handleCheckBoxChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      setCheckboxState('all');
    } else {
      setCheckboxState();
    }
  };

  return (
    <Flex jcc aic>
      <StyledIcon
        type='angle-right'
        size='lg'
        open={defaultExpanded}
        onClick={onClick}
      />
      {allChildrenCheckBox && <StyledCheckboxWrapper
        className='ag-labeled ag-label-align-right ag-checkbox ag-input-field ag-header-select-all ag-header-select-all-details'
      >
        <div className='ag-input-field-label ag-label ag-hidden ag-checkbox-label' role='presentation' />
        <div className={`ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ${checkboxState === 'all' && 'ag-checked'}`} role='presentation'>
          <input
            className='ag-input-field-input ag-checkbox-input'
            type='checkbox' id='ag-302-input'
            aria-label='Press Space to toggle all rows selection (unchecked)'
            tabIndex='-1'
            onChange={handleCheckBoxChange}
          />
        </div>
      </StyledCheckboxWrapper>
      }
    </Flex>
  );
};

MasterDetailHeader.propTypes = {
  allChildrenCheckBox: PropTypes.bool,
};

export default MasterDetailHeader;
